;(function () {
  'use strict'

  angular
    .module('contrast.libraries')
    .controller('csLibraryBugtrackerCtrl', csLibraryBugtrackerCtrl)

  function csLibraryBugtrackerCtrl() {
    var vm = this

    angular.extend(vm, {
      hasBugtrackers: hasBugtrackers,
      getPlacement: getPlacement,
      getSize: getSize
    })

    function hasBugtrackers() {
      return angular.isArray(vm.bugtrackers) && vm.bugtrackers.length > 0
    }

    function getPlacement() {
      return angular.isString(vm.placement) ? vm.placement : 'bottom'
    }

    function getSize() {
      return angular.isNumber(vm.size) ? vm.size : 13
    }
  }
})()
